import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';

import * as utils from '../../../utils/utilities';

class HelideckVisualInspectionItem extends Form {
	state = {
		data: {
			inspectedItem: '',
			observation: '',
			remark: '',
			images: [],
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		inspectedItem: Joi.string().allow('').required().label('Inspected Item'),
		observation: Joi.string().min(10).required().label('Observation'),
		remark: Joi.string().required().label('Remark'),
		images: Joi.array().min(0).required().label('Images'),
	};

	static propTypes = {
		onAdd: PropTypes.func,
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onAdd(this.state.data);

		this.setState({
			data: {
				inspectedItem: '',
				observation: '',
				remark: '',
				images: [],
			},
		});
	};
	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'inspectedItem',
							placeholder: 'Enter Inspected Item',
							label: 'Inspected Item',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'observation',
							placeholder: 'Enter Observation',
							label: 'Observation',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'remark',
							placeholder: 'Enter Remark',
							label: 'Remark',
						})}
					</div>

					<div className="col">
						{this.renderFileInput({
							max: 4,
							multiple: true,
							name: 'images',
							accept: 'image/*,application/pdf',
							label: 'Images',
							sublabel: 'Upload Photo Ref.',
							types: utils.getFileUploadTypes(),
						})}
					</div>
				</div>

				{this.renderButton('Submit')}
			</form>
		);
	}
}

export default HelideckVisualInspectionItem;
